var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("label", [
    _c("span", { staticClass: "select-label" }, [_vm._v("по")]),
    _vm._v(" "),
    _c(
      "select",
      { attrs: { name: "count_on_page" } },
      [
        _vm._l(4, function(i) {
          return _c(
            "option",
            {
              key: i,
              domProps: {
                value: _vm.count * i,
                selected: _vm.count * i == _vm.current
              }
            },
            [_vm._v(_vm._s(_vm.count * i))]
          )
        }),
        _vm._v(" "),
        _c(
          "option",
          {
            attrs: { value: "9999999" },
            domProps: { selected: _vm.current == 9999999 }
          },
          [_vm._v("Все")]
        )
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74f88a04", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74f88a04","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/webpack/vue/backend/components/SelectOn.vue
// module id = 167
// module chunks = 1